import { safeApiCall } from "api/common.service";
import { getAgedTrialBalanceReport } from "api/report.service";
import { useCallback, useEffect, useState } from "react";
import { AgedTrialBalances } from "types/model.types";

export const useAgedTrialBalance = () => {
  const [data, setData] = useState<AgedTrialBalances>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const result = await safeApiCall(getAgedTrialBalanceReport());
      setData(result ?? []);
    } catch (err: any) {
      console.error("Failed to load Aged Trial Balance", err);
      setError("Failed to load Aged Trial Balance");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    data,
    loading,
    error,
    refresh: fetchData,
  };
};
